function dateFormat(dateNumber){
    let date = new Date(dateNumber);
    return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
}

function generateRandomString(numSymbol, withCapitalLetter){
    let result = '';
    let words = withCapitalLetter ? '0123456789qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM'
        : '0123456789qwertyuiopasdfghjklzxcvbnm';
    let max_position = words.length - 1;

    for(let i = 0; i < numSymbol; ++i ) {
        let position = Math.floor ( Math.random() * max_position );
        result = result + words.substring(position, position + 1);
    }
    return result;
}

export {dateFormat, generateRandomString}


// WEBPACK FOOTER //
// ./src/utils/utils.js